/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourceReference
 */
export interface SourceReference {
    /**
     * 
     * @type {string}
     * @memberof SourceReference
     */
    sourceSystem?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceReference
     */
    sourceRecordId?: string;
    /**
     * 
     * @type {Date}
     * @memberof SourceReference
     */
    lastSyncedAt?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof SourceReference
     */
    contributedFields?: Array<string>;
}

/**
 * Check if a given object implements the SourceReference interface.
 */
export function instanceOfSourceReference(value: object): value is SourceReference {
    return true;
}

export function SourceReferenceFromJSON(json: any): SourceReference {
    return SourceReferenceFromJSONTyped(json, false);
}

export function SourceReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourceReference {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceSystem': json['sourceSystem'] == null ? undefined : json['sourceSystem'],
        'sourceRecordId': json['sourceRecordId'] == null ? undefined : json['sourceRecordId'],
        'lastSyncedAt': json['lastSyncedAt'] == null ? undefined : (new Date(json['lastSyncedAt'])),
        'contributedFields': json['contributedFields'] == null ? undefined : json['contributedFields'],
    };
}

export function SourceReferenceToJSON(json: any): SourceReference {
    return SourceReferenceToJSONTyped(json, false);
}

export function SourceReferenceToJSONTyped(value?: SourceReference | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceSystem': value['sourceSystem'],
        'sourceRecordId': value['sourceRecordId'],
        'lastSyncedAt': value['lastSyncedAt'] == null ? undefined : ((value['lastSyncedAt']).toISOString()),
        'contributedFields': value['contributedFields'],
    };
}

